export default function () {
  return {
    current: {
      id: '',
      name: '',
      description: '',
      tagCount: 0
    },
    update: {
      id: '',
      name: '',
      description: ''
    },
    list: []
  }
}
